export const ITR_updateShowITRWelcomeScreenReducer = {
  ITR_updateShowITRWelcomeScreen: (state, action) => {
    state.showITRWelcomeScreen = action.payload;
  },
};
